"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatingWeekdaysEditor = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const Weekdays_1 = require("../../../Form/Field/Weekdays");
const RepeatingWeekdaysEditor = (props) => {
    const { field, firstDay } = props;
    const { value, onValue } = field;
    const firstDateWeekday = (0, moment_1.default)(firstDay).format('dddd').toLowerCase();
    (0, react_1.useEffect)(() => {
        if (firstDateWeekday)
            onValue([firstDateWeekday]);
    }, [onValue, firstDateWeekday]);
    const onChange = (0, react_1.useCallback)((weekdays) => {
        const result = weekdays.filter(x => x !== firstDateWeekday);
        if (firstDateWeekday)
            result.push(firstDateWeekday);
        onValue(result);
    }, [onValue, firstDateWeekday]);
    return (react_1.default.createElement(Weekdays_1.FormFieldWeekdays, { isShowLabel: false, value: value, setValue: onChange }));
};
exports.RepeatingWeekdaysEditor = RepeatingWeekdaysEditor;
//# sourceMappingURL=RepeatingWeekdaysEditor.js.map